/**
 * 组织架构实体组件
 */

import { useState, useEffect } from 'react';
import {
    Flex,
    Modal,
    Input,
    Row,
    Col,
    message,
    InputNumber,
    Select,
    Upload,
    Image,
    Typography,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import $ from 'jquery';
import {
    AddRequestHeaders,
    UjoinParams,
    uploadImageButton,
    AliyunOSSclient,
    AliyunOSSDelete,
    uuid,
    GetBase64,
} from '../../incs/FunHelper';
import ImgCrop from 'antd-img-crop';

import CNF from '../../incs/Config';

const MODULENAME = '组织架构';

const { TextArea } = Input;
const { Text } = Typography;


const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [ulid, setULID] = useState('');    // 当前架构ULID
    const [orgInfoULID, setOrgInfoULID] = useState('');   //  组织信息ULID
    const [orgStructuresLists, setOrgStructuresLists] = useState('');   //  组织架构列表

    const [upSID, setUpSID] = useState(''); //  上级组织sid
    const [level, setLevel] = useState(1); //  组织层级
    const [sn, setSN] = useState(1); //  层级序号
    const [orgFunctionType, setOrgFunctionType] = useState(CNF.orgFunctionTypes[1].value); //  组织职能类型
    const [title, setTitle] = useState(''); // 架构名称
    const [name, setName] = useState(''); // 负责人员
    const [description, setDescription] = useState(''); // 备注

    const [fileList, setFileList] = useState([]);    //  图片列表
    const [previewOpen, setPreviewOpen] = useState(false); //  图片预览是否打开
    const [previewImage, setPreviewImage] = useState(''); //  图片预览资源
    const [deleteFileList, setDeleteFileList] = useState([]); //  删除图片列表
    const [orgImageList, setOrgImageList] = useState([]);   //  组织人员图片列表

    const quit = () => {
        props.setOpen(false);
        setLoading(false);
        setULID('');
        setOrgStructuresLists('');
        setUpSID('');
        setLevel(1);
        setSN(1);
        setOrgFunctionType(CNF.orgFunctionTypes[1].value);
        setTitle('');
        setName('');
        setDescription('');

        setFileList([]);
        setPreviewOpen(false);
        setPreviewImage('');
        setDeleteFileList([]);
        setOrgImageList([]);
    };

    const cancel = () => {
        quit();
        if (!props.record) {
            // 新增情况下取消，则删除已上传的图片
            aliyunOSSDeleteFileList(fileList);
            aliyunOSSDeleteFileList(deleteFileList);    //  待删除的文件
        } else {
            // 修改取消情况下，删除新增已上传的文件
            if (fileList && fileList.length > 0) {
                for (let i = 0; i < fileList.length; i++) {
                    let item = fileList[i];
                    // 如果不是原始图片则删除
                    if (!orgImageList.find(e => e.url === item.url)) {
                        AliyunOSSDelete(item);
                    }
                }
            }
        }
    };

    useEffect(() => {
        // 获取组织信息列表, 默认选中第一个
        if (props.orgInfosLists.length > 0) {
            setOrgInfoULID(props.orgInfosLists[0].key);
        }
    }, [props.orgInfosLists]);

    useEffect(() => {
        // 修改初始化
        if (props.record && props.record.key !== ulid) {
            setULID(props.record.key);
            setOrgInfoULID(props.record.org_info_ulid);
            setUpSID(props.record.up_sid);
            setLevel(props.record.level);
            setSN(props.record.sn);
            setOrgFunctionType(props.record.org_function_type);
            setTitle(props.record.title);
            setName(props.record.name);
            setDescription(props.record.description);

            // 拉取图片
            if (props.record.icon_uri) {
                let orgImageList = [];
                const url = CNF.ossApi + props.record.icon_uri;
                orgImageList.push({
                    uid: 1,
                    url: url,
                    path: props.record.icon_uri,
                    preview: url,
                    status: 'done',
                    percent: 100,
                });
                setFileList(orgImageList);
                setOrgImageList(orgImageList);
            }
        }
    }, [props.record, ulid]);


    useEffect(() => {
        /**
         * 获取上级组织架构下拉列表
         */
        const getUpStructuresLists = () => {
            const params = {
                rss: 'list',
                org_info_ulid: orgInfoULID,
                status: CNF.status[0].value,
            };
            $.ajax({
                url: `${CNF.api}orgs/structures${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setOrgStructuresLists(data.dat);
                        }
                    }
                }
            })
        }
        if (props.open && orgInfoULID) {
            getUpStructuresLists();
        }
    }, [props.open, orgInfoULID])

    /**
     * 文件上传前钩子
     * @param {*} file 
     */
    const beforeUpload = (file) => {
        //  判断格式
        if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
            messageApi.error('上传图片格式错误！', CNF.messageDuration);
            return false;
        }
        if (file.size > 204800) {
            messageApi.error('上传图片超过200KB, 请重新上传! ', CNF.messageDuration);
            return false;
        }
        return true;
    }

    /**
     * 图片预览操作绑定函数
     * @param {*} file 
     */
    const preview = (file) => {
        if (!file.preview) {
            if (file.originFileObj) {
                //  转换图片，用于缩略图展示
                GetBase64(file.originFileObj, (imageObj) => {
                    file.preview = imageObj;
                });
            } else {
                file.preview = file.url;
            }
        }
        setPreviewImage(file.preview || file.url);
        setPreviewOpen(true);
    }

    /**
     * 通用上传到阿里云 OSS
     * @param {File} file
     * @param {Function} setFileList
     * @param {Array} fileList
     */
    const aliyunOSSUpload = (file, setFileList, fileList) => {
        const headers = {
            //  文件acl授权为公共读
            'x-oss-object-acl': 'public-read'
        }

        const params = {
            acl: 'PutObject',
        }

        // 手动添加文件到列表，标记为新文件
        const newFile = {
            uid: file.uid,
            name: file.name,
            status: 'uploading',
            percent: 0,
            url: '',
            path: '',
            isNew: true,
            originFileObj: file,
        };

        setFileList(prev => [...prev, newFile]);

        $.ajax({
            url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',
            success: function (data) {
                if (data.res === 0) {
                    const token = data.dat;
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onloadend = () => {
                        //  路径由以下部分组成
                        //  项目代码+avatar+组织前缀+uuid+附件名（去除空格）
                        let path = CNF.projectCode.toLowerCase()
                        path += '/orgs';
                        path += '/' + props.preGroup;
                        path += '/' + uuid;
                        path += '/' + file.name.replace(/\s/g, '');
                        AliyunOSSclient(token).multipartUpload(path, file,
                            {
                                // 请求头
                                headers,
                                // 获取分片上传进度、断点和返回值
                                progress: (p) => {
                                    setFileList(prev =>
                                        prev.map(item =>
                                            item.uid === file.uid
                                                ? {
                                                    ...item,
                                                    percent: parseInt(p * 100),
                                                    status: p === 1 ? 'done' : 'uploading',
                                                    url: CNF.ossApi + path,
                                                    path: path,
                                                }
                                                : item
                                        )
                                    );
                                },
                                // 分片数量
                                parallel: Math.ceil(file.size / 1024 / 1024),
                                // 设置分片大小，默认为1M。
                                partSize: 1024 * 1024,
                                mime: "text/plain",
                            }).then((result) => {
                                //  上传成功
                                if (result.res.status === 200) {
                                }
                            }).catch((e) => {
                                //  上传失败
                                messageApi.error(file.name + ' 上传失败！', CNF.messageDuration);
                                setFileList(prev => prev.filter(item => item.uid !== file.uid));
                            });
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            },
            error: function () {
                messageApi.error('获取STS Token失败！', CNF.messageDuration);
            }
        });
    }

    /**
     * 删除图片列表
     * @param {*} deleteFileArr 
     */
    const aliyunOSSDeleteFileList = (deleteFileArr) => {
        if (!deleteFileArr || deleteFileArr.length === 0) return;

        for (let file of deleteFileArr) {
            //  从阿里云上删除
            AliyunOSSDelete(file);
        }
        setDeleteFileList([]);
    }


    const ok = () => {
        // 参数校验
        if (!title) {
            messageApi.error('组织标题不能为空！');
            return;
        }

        if (!orgFunctionType) {
            messageApi.error('组织职能不能为空！');
            return;
        }

        setLoading(true);

        $.ajax({
            url: CNF.api + 'orgs/structures' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                org_info_ulid: orgInfoULID,
                up_sid: upSID,
                level,
                sn,
                org_function_type: orgFunctionType,
                title,
                name,
                icon_uri: fileList.length > 0 ? fileList[0].path : '',
                description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                // 如果有需要删除的图片
                if (deleteFileList.length > 0) aliyunOSSDeleteFileList(deleteFileList); // 同步删除阿里云文件
                setTimeout(function () {
                    quit();
                    props.refresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false);
        }, CNF.messageDuration * 1000))
    };


    return (
        <>
            {contextHolder}
            <Modal
                width={600}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                style={{ top: 0 }}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={24}><Text>组织实体</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Select
                                allowClear
                                showSearch
                                value={orgInfoULID || undefined}
                                style={{ width: '100%' }}
                                onChange={(value) => setOrgInfoULID(value ?? '')}
                                disabled={props.record ? true : loading}
                                filterOption={(input, option) =>
                                    option?.label?.toLowerCase().includes(input.toLowerCase())
                                }
                                options={(props.orgInfosLists || []).map(item => ({
                                    value: item.key,
                                    label: item.name,
                                    key: item.key
                                }))}
                                notFoundContent='暂无数据'
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>上级架构</Text></Col>
                        <Col span={24}>
                            <Select
                                allowClear
                                showSearch
                                placeholder='请选择'
                                value={upSID || undefined}
                                style={{ width: '100%' }}
                                onChange={(value, option) => {
                                    setUpSID(value ?? '');
                                    if (option) {
                                        setLevel(option.level + 1);
                                    }
                                }}
                                disabled={props.record || loading}
                                filterOption={(input, option) =>
                                    option?.label?.toLowerCase().includes(input.toLowerCase())
                                }
                                options={(orgStructuresLists || [])
                                    .filter(item =>
                                        parseInt(item.org_function_type) !== parseInt(CNF.orgFunctionTypes[2].value)
                                    )
                                    .map(item => ({
                                        value: item.sid,
                                        label: item.title,
                                        level: item.level,
                                        key: item.sid,
                                    }))
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>架构层级</Text><Text type='danger'>*</Text></Col>
                        <Col span={11} offset={2}><Text>层级序号</Text><Text type='danger'>*</Text></Col>
                        <Col span={11}>
                            <InputNumber
                                onChange={(value) => setLevel(value)}
                                placeholder='架构层级'
                                value={level}
                                min={1}
                                max={9}
                                style={{ width: '100%' }}
                                disabled={true}
                            />
                        </Col>
                        <Col span={11} offset={2}>
                            <InputNumber
                                onChange={(value) => setSN(value)}
                                placeholder='架构序号'
                                value={sn}
                                min={1}
                                max={12}
                                style={{ width: '100%' }}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>架构标题</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Input
                                onChange={(e) => setTitle(e.target.value)}
                                placeholder='请输入'
                                value={title}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>架构职能</Text><Text type='danger'>*</Text></Col>
                        <Col span={11} offset={2}><Text>负责人员</Text></Col>
                        <Col span={11}>
                            <Select
                                allowClear
                                showSearch
                                value={orgFunctionType || undefined}
                                style={{ width: '100%' }}
                                placeholder='请选择'
                                onChange={(value) => setOrgFunctionType(value ?? '')}
                                disabled={loading}
                                filterOption={(input, option) =>
                                    option?.label?.toLowerCase().includes(input.toLowerCase())
                                }
                                options={CNF.orgFunctionTypes.map(item => ({
                                    value: item.value,
                                    label: item.key,
                                    key: item.value
                                }))}
                                notFoundContent='暂无数据'
                            />
                        </Col>
                        <Col span={11} offset={2}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setName(e.target.value)}
                                value={name}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} >人员图像</Col>
                        <Col span={24}>
                            <ImgCrop rotationSlider>
                                <Upload
                                    listType='picture-card'
                                    beforeUpload={(file) => {
                                        if (beforeUpload(file)) {
                                            aliyunOSSUpload(file, setFileList, fileList);
                                        }
                                        return false;
                                    }}
                                    icon={<PlusOutlined />}
                                    customRequest={() => { }}
                                    fileList={fileList}
                                    onPreview={preview}
                                    disabled={loading}
                                    onRemove={(file) => {
                                        setFileList(prev => prev.filter(item => item.uid !== file.uid));
                                        setDeleteFileList(prev => [...prev, file]);
                                    }}
                                >
                                    {fileList.length >= 1 ? null : uploadImageButton}
                                </Upload>
                                {previewImage && (
                                    <Image
                                        wrapperStyle={{ display: 'none', }}
                                        preview={{
                                            visible: previewOpen,
                                            onVisibleChange: (visible) => setPreviewOpen(visible),
                                            afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                        }}
                                        src={previewImage}
                                        disabled={loading}
                                    />
                                )}
                            </ImgCrop>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>架构描述</Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                onChange={(e) => setDescription(e.target.value)}
                                value={description}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity